// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"jq-z","outfitFeedbackSection":"kq-z"};